'use client'

import { useTranslations } from '@/lib/next-shim'
import api from '@/lib/api'
import { OtpVerificationDialog } from '@/shared/ui/dialog/OtpVerificationDialog'

type Props = {
  open: boolean
  sentTo: string
  onClose: () => void
  onConfirmed: () => void
}

export function IdentityChangeOtpDialog({ open, sentTo, onClose, onConfirmed }: Props) {
  const t = useTranslations('component.identityChangeOtpDialog')

  return (
    <OtpVerificationDialog
      open={open}
      onClose={onClose}
      onVerified={onConfirmed}
      autoSendOnOpen={false}
      onSendOtp={async (resend) => {
        try {
          await api.auth.sendIdentityChangeOtp(resend)
          return true
        } catch {
          return false
        }
      }}
      onVerifyOtp={async (otp) => {
        try {
          return await api.auth.verifyIdentityChangeOtp(otp)
        } catch {
          return false
        }
      }}
      title={t('title')}
      description={
        <>
          {t('description')}
          <strong> {sentTo}</strong>.
        </>
      }
      sentInfo={t('messages.resent')}
      sendError={t('errors.resend')}
      verifyError={t('errors.invalid')}
      resendLabel={t('actions.resend')}
      cancelLabel={t('actions.cancel')}
      confirmLabel={t('actions.confirm')}
      closeLabel={t('actions.close')}
    />
  )
}
